import GuestyIntegration from './guesty-integration';

export default GuestyIntegration;
